import React from 'react'
import search from '../onboard/img/search.gif'
import { OnBoardingContentImage } from '../../../Onboard/OnBoardingContentImage'

export const steps = [
  {
    target: '[data-joyridestep="general_search"]',
    text: (
      <>
        <OnBoardingContentImage src={search} />
        <div> Search for product. You can search by size, shape or description</div>
      </>
    ),
    tip: <>Specify measurement to search by size.</>,
    title: 'Search',
    spotlightClicks: true,
  },
]
